import { Calendar } from 'vanilla-calendar-pro';
import { format } from 'date-format-parse';

const defaultConfig = {
    inputMode: true,
    locale: 'de-DE',
    firstWeekday: 1,
    enableWeekNumbers: true,
    selectedTheme: 'light',
    timeStepMinute: 5,
    selectedDates: [new Date()],
    onChangeToInput(self) {
        if (!self.context.inputElement) return;

        let dateformat = self.context.inputElement.getAttribute('dateFormat');
        switch (dateformat) {
            case 'd.m.Y':
                dateformat = 'DD.MM.YYYY';
                break;
            case 'd.m.Y H:i':
                dateformat = 'DD.MM.YYYY HH:mm';
                break;
            case 'd.m.Y H:i:s':
                dateformat = 'DD.MM.YYYY HH:mm:ss';
                break;
        }

        let date = '';
        if (self.context.selectedDates[0]) {
          date = self.context.selectedDates[0];
        }

        let time = '';
        if (self.context.selectedTime) {
          time = self.context.selectedTime;
        }

        if (date || time) {
            let dateObj = new Date(date + (time ? 'T' + time : ''));
            self.context.inputElement.value = format(dateObj, dateformat);
        } else {
            self.context.inputElement.value = '';
        }

        self.context.inputElement.dispatchEvent(new Event('change'));
    },
};

function getConfig(config) {
    const intValues = [
        'timeMinHour',
        'timeMaxHour',
        'timeMinMinute',
        'timeMaxMinute',
        'timeStepHour',
        'timeStepMinute',
    ];

    Array.from(intValues).forEach((value) => {
        if (config.hasOwnProperty(value) && config[value]) {
            config[value] = Number(config[value]);
        }
    });

    return {
        ...config,
        ...defaultConfig,
    };
}

export function initDatePicker(element: HTMLInputElement) {
    let config = {};

    if (element.dataset.config) {
        try {
            config = JSON.parse(element.dataset.config) || {};
        } catch (error) {
            console.error('Error parsing config:', error);
        }
    }

    if (element.value) {
        config.selectedDates = [new Date(element.value)];
    }

    const calendar = new Calendar(element, getConfig(config));
    calendar.init();
}

export function initDatePickers() {
    const elements = document.querySelectorAll('.form-datepicker');
    if (elements.length === 0) return;

    elements.forEach(element => initDatePicker(element as HTMLInputElement));
}
